import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const ListEditor = ({ label, columns, rows = [], onChange, blank, testId }) => {
  const update = (i, k, v) => onChange(rows.map((r, idx) => (idx === i ? { ...r, [k]: v } : r)));
  return (
    <div className="space-y-2 sm:col-span-2" data-testid={testId}>
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium">{label} <span className="text-slate-400 font-normal">({rows.length})</span></p>
        <Button type="button" size="sm" variant="outline" className="rounded-full h-8" onClick={() => onChange([...rows, { ...blank }])} data-testid={`${testId}-add`}><Plus size={14} className="mr-1" /> Tambah</Button>
      </div>
      {rows.map((r, i) => (
        <div key={i} className="flex gap-2 items-center">
          <span className="text-xs text-slate-400 w-5">{i + 1}.</span>
          {columns.map((c) =>
            c.type === "select" ? (
              <Select key={c.key} value={String(r[c.key] ?? "")} onValueChange={(v) => update(i, c.key, v)}>
                <SelectTrigger className="h-9" style={{ flex: c.flex || 1 }} data-testid={`${testId}-${i}-${c.key}`}><SelectValue placeholder={c.label} /></SelectTrigger>
                <SelectContent>{c.options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}</SelectContent>
              </Select>
            ) : (
              <Input key={c.key} type={c.type || "text"} className="h-9" style={{ flex: c.flex || 1 }} placeholder={c.label} value={r[c.key] ?? ""} onChange={(e) => update(i, c.key, e.target.value)} data-testid={`${testId}-${i}-${c.key}`} />
            )
          )}
          <button type="button" onClick={() => onChange(rows.filter((_, idx) => idx !== i))} className="text-slate-400 hover:text-red-600" data-testid={`${testId}-${i}-remove`}><Trash2 size={15} /></button>
        </div>
      ))}
    </div>
  );
};
